import { ApiProject } from "@incendium/api";
import { listSourceCategories } from "features/sourceCategories/services/sourceCategoryService";
import { useProjectSharedState } from "Hooks/useSharedState";

const fetchSourceCategories = async (project: ApiProject) => {
  return listSourceCategories(project.id!);
};

export const useSourceCategories = () => {
  const { state, setState, loading, fetched } = useProjectSharedState(
    "sourceCategories",
    [],
    fetchSourceCategories
  );

  return {
    sourceCategories: state,
    setSourceCategories: setState,
    loading,
    fetched,
  };
};
